/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* rfce */
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Header from "./components/header";
import SectionTwo from "./components/sectiontwo";
import Appeals from "./components/appeals";
import "./App.css";
import { BrowserRouter as Router, Route, Routes, Switch, IndexRoute } from "react-router-dom";
import Home from "./components/Home";
import Emergencies from "./components/emergencies";
import SectionThree from "./components/sectionthree";
import {BackTop} from 'antd';
import E from "./components/e";



function App() {
  return (
    <>
      <Router>
        <Navbar/>
        <div id="wrapper" className="clearfix">
          <Routes>
            <Route path="/" element={<Home />}/>
            <Route path="/appeals" element={<Appeals />} />
            <Route path="/emergencies" element={<Emergencies/>} />
            <Route path="/e/:id" element={<E/>} />
            <Route path="/sectionthree" element={<SectionThree/>} />
          </Routes>
        </div>
        <Footer/>
      </Router>
    </>
  );
}

export default App;
